import { render, staticRenderFns } from "./QuizTeamResultText.vue?vue&type=template&id=58d4544e&scoped=true&"
import script from "./QuizTeamResultText.vue?vue&type=script&lang=js&"
export * from "./QuizTeamResultText.vue?vue&type=script&lang=js&"
import style0 from "./QuizTeamResultText.vue?vue&type=style&index=0&id=58d4544e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d4544e",
  null
  
)

export default component.exports